export var MenuEvent;
(function (MenuEvent) {
    MenuEvent["Select"] = "v-select";
    MenuEvent["LabelChange"] = "v-label-change";
})(MenuEvent || (MenuEvent = {}));
